import { use } from "react";
import { ClientProfile, ProfileType, WorkerProfile } from "../__generated__/graphql";
import { ProfileSwitcherManagerContext } from "../contexts/ProfileSwitcherManager";
import { AuthManagerContext } from "../contexts/AuthManager";
import { XOR } from "ts-essentials";

export const useCurrentProfile = <V extends XOR<WorkerProfile, ClientProfile> | undefined>(): V => {
    const { profileType, profileId } = use(ProfileSwitcherManagerContext);
    const { user } = use(AuthManagerContext);

    if (profileId === undefined) {
        return undefined as V;
    }

    if (profileType === ProfileType.Worker) {
        return (user?.workerProfile?.id === profileId ? user.workerProfile : undefined) as V;
    } else if (profileType === ProfileType.Client) {
        return user?.clientProfiles?.find((clientProfile) => clientProfile.id === profileId) as V;
    }

    return undefined as V;
};
